module.exports = __webpack_public_path__ + "amcharts/images/dragIconRoundSmallBlack.svg";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=amcharts/images/[name].[ext]!./~/amstock3/amcharts/images/dragIconRoundSmallBlack.svg
// module id = 257
// module chunks = 0